export type SubmitRequest = {
  company_name: string;
  company_domain: string;
  requested_by: string;
};

export type SubmitSuccess = {
  status: "accepted";
  job_id: string;
};

export type SubmitError = {
  status: "error";
  message: string;
};

export type SubmitResponse = SubmitSuccess | SubmitError;

export type QuickInsightsStatus = "pending" | "complete" | "error";

export type DpdpaApplicabilityLevel =
  | "VERY_LIKELY"
  | "LIKELY"
  | "POSSIBLY"
  | "UNLIKELY";

export type QuickInsightsConfidence = "HIGH" | "MEDIUM" | "LOW";

export type AreaUnderReview = {
  area: string;
  dpdpa_references: string[];
  redacto_product_hint: string;
  why_this_is_being_checked: string;
};

export type QuickInsights = {
  type: string;
  summary: string;
  confidence: QuickInsightsConfidence | string;
  full_report: {
    status: string;
    message: string;
  };
  generated_at: string;
  educational_note: {
    title: string;
    message: string;
  };
  areas_under_review: AreaUnderReview[];
  company_understanding: {
    business_profile: string;
    likely_user_relationship: string;
    likely_digital_touchpoints: string[];
  };
  likely_data_to_validate: string[];
  dpdpa_applicability_signal: {
    level: DpdpaApplicabilityLevel | string;
    reason: string;
  };
};

export type StatusInProgress = {
  job_id: string;
  status: "pending" | "researching" | "analysis_complete" | "complete";
  company_name: string;
  quick_insights_status: QuickInsightsStatus;
  quick_insights?: QuickInsights;
  quick_insights_generated_at?: string;
};

export type StatusErrorShape = {
  status: "error";
  message: string;
};

export type StatusResponse = StatusInProgress | StatusErrorShape;

export class ApiError extends Error {
  status?: number;
  constructor(message: string, status?: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}
